// extracted by mini-css-extract-plugin
export var statItem = "_dh-1";
export var statsRow = "_dh-0";